import React, { useState, useEffect } from 'react';
import ChartWeakness from './ChartWeakness';
import { fetchData } from './FetchData';

function filterData(data) {
  return data.filter((d) => {
    return true;
  });
}

function prepareChartWeaknessData(data) {
  // usually more wrangling is required but the example data is simple
  return data;
}

const useData = (dataSet) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewData = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await fetchData(dataSet);
        const dataClean = filterData(data);
        setData(prepareChartWeaknessData(dataClean));
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError(err);
        setLoading(false);
      }
    };
    fetchNewData();
  }, [dataSet]);

  return [data, loading, error];
};

const ChartWeaknessData = () => {
  const [dataSet, setDataSet] = useState('dataWeakness');
  const [data, loading, error] = useData(dataSet);

  return (
    <>
      <ChartWeakness data={data} error={error} loading={loading} />
    </>
  );
};

export default ChartWeaknessData;
